import { Box, Grid, Hidden, ResizableDrawer, Stack } from "@biggeo/bg-ui/lab";
import { ReactNode, useState } from "react";

export type MapDrawerLayoutProps = {
    children?: ReactNode;
    sidebar?: ReactNode;
    tabBar?: ReactNode;
    left?: ReactNode;
    bottom?: React.FC<{
        hasTransitioned: boolean;
    }>;
    top?: ReactNode;
    leftSize?: number;
    bottomSize?: number;
    topSize?: number;
    leftOpen?: boolean;
    bottomOpen?: boolean;
    topOpen?: boolean;
    onLeftOpenChange?: (open: boolean) => void;
};

export const MapDrawerLayout = ({
    children,
    sidebar,
    tabBar,
    left,
    bottom,
    top,

    leftSize = 270,
    topSize = 42,

    leftOpen = false,
    bottomOpen = false,
    topOpen = false,

    onLeftOpenChange,
}: MapDrawerLayoutProps) => {
    const [hasBottomTransitioned, setHasBottomTransitioned] = useState(false);

    return (
        <Grid
            container
            flexWrap="nowrap"
            height="100%"
            sx={{
                containerType: "inline-size",
                position: "relative",
            }}
        >
            <Hidden item height="100%" breakpoint="cmd">
                {sidebar}
            </Hidden>
            <ResizableDrawer
                onOpenChange={onLeftOpenChange}
                open={leftOpen}
                resizeDirection="right"
                size={leftSize}
                sx={{
                    maxWidth: "90%",
                    minWidth: leftOpen ? 45 : 0,
                    borderRight: 1,
                    borderColor: (theme) => theme.palette.stroke[100],
                    flexDirection: "column",
                    display: "none",
                    breakpoints: {
                        cmd: {
                            display: "flex",
                        },
                    },
                }}
            >
                {left}
            </ResizableDrawer>
            <Grid height="100%" item xs minWidth={0}>
                <Stack height="100%" width="100%">
                    <Box
                        sx={{
                            height: topOpen ? `${topSize}px` : 0,
                            borderBottom: topOpen ? 1 : 0,
                            borderColor: (theme) => theme.palette.stroke[100],
                            transition: "height 0.2s ease-in-out",
                        }}
                    >
                        {top}
                    </Box>
                    <Grid item xs width="100%" display="flex" minHeight={0}>
                        {children}
                    </Grid>
                    <Box
                        sx={{
                            height: bottomOpen ? "50%" : 0,
                            borderTop: bottomOpen ? 1 : 0,
                            borderColor: (theme) => theme.palette.stroke[100],
                            transition: "height 0.2s ease-in-out",
                        }}
                        onTransitionEnd={(e) => {
                            if (e.propertyName === "height") {
                                setHasBottomTransitioned(true);
                            }
                        }}
                    >
                        {bottom?.({ hasTransitioned: hasBottomTransitioned })}
                    </Box>
                    <ResizableDrawer
                        strategy="absolute"
                        onOpenChange={onLeftOpenChange}
                        open={leftOpen}
                        resizeDirection="up"
                        size={leftSize}
                        sx={{
                            maxHeight: "90%",
                            minHeight: leftOpen ? "102px" : 0,
                            bottom: "61px",
                            borderTop: 1,
                            borderColor: (theme) => theme.palette.stroke[100],
                            backgroundColor: (theme) =>
                                theme.palette.background.container,
                            flexDirection: "column",
                            display: "flex",
                            breakpoints: {
                                cmd: {
                                    display: "none",
                                },
                            },
                        }}
                    >
                        {left}
                    </ResizableDrawer>
                    <Hidden breakpoint="cmd" variant="up">
                        {tabBar}
                    </Hidden>
                </Stack>
            </Grid>
        </Grid>
    );
};
